class predictiveSearch extends HTMLElement {
  constructor() {
    super();
    // console.log('predictive search init');
    this.includeCollections =
      this.dataset.includeCollections === "true" ? true : false;
    this.excludedCollections = this.dataset.excludedCollections
      ? this.dataset.excludedCollections.split(",")
      : [];
    this.translationNoResults = this.dataset.translationNoResults;
    this.translationCollection = this.dataset.translationCollection;

    this.apiLock = {
      locked: false,
      set lock(state) {
        this.locked = state;
        // console.log('apiLock:', state);
      },
    };

    this.inputBottomBorder = {
      round: () => {
        this.input.classList.remove("search-results--open");
      },
      square: () => {
        this.input.classList.add("search-results--open");
      },
    };
  }

  connectedCallback() {
    this.resultList = this.querySelector("#resultList");
    this.input = this.querySelector("#search-input");
    this.closeX = this.querySelector("#closeX");
    this.searchIcon = this.querySelector("#input-search-icon");

    this.searchIcon.addEventListener("click", () => {
      this.input.focus();
    });

    // close search on outside click
    window.addEventListener("click", (e) => {
      if (
        this.resultList &&
        !this.resultList.contains(e.target) &&
        !this.input.contains(e.target)
      ) {
        this.input.value = "";
        this.emptyDropdown();
        this.hideCloseX();
      }
    });

    // close search on Escape-keyup
    window.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        this.input.value = "";
        this.emptyDropdown();
        this.hideCloseX();
      }
    });

    // enable keyboard navigation
    window.addEventListener("keyup", (e) => {
      this.resultListItems = Array.from(this.resultList.querySelectorAll("li"));

      if (e.code === "ArrowDown") {
        if (
          this.resultListItems.length === 1 &&
          this.resultListItems[0].innerHTML.includes(this.translationNoResults)
        ) {
          return;
        }

        let selected = this.resultList.querySelectorAll(
          ".search-result_selected"
        )[0];

        if (!selected && this.resultListItems.length > 0) {
          this.resultListItems[0].classList.add("search-result_selected");
          this.resultListItems[0].focus({ preventScroll: false });
          selected = this.resultListItems[0];
        } else if (selected && selected.nextElementSibling) {
          selected.classList.remove("search-result_selected");
          selected.nextElementSibling.classList.add("search-result_selected");
          selected.nextElementSibling.focus({ preventScroll: false });
        }
      }

      if (e.code === "ArrowUp") {
        let selected = this.resultList.querySelectorAll(
          ".search-result_selected"
        )[0];

        if (!selected) {
          return;
        } else {
          selected.classList.remove("search-result_selected");
          if (selected.previousElementSibling) {
            selected.previousElementSibling.classList.add(
              "search-result_selected"
            );
            selected.previousElementSibling.focus({ preventScroll: false });
          }
        }
      }
    });

    window.addEventListener("keyup", (e) => {
      if (e.code === "Enter") {
        let selected = this.resultList.querySelectorAll(
          ".search-result_selected"
        )[0];
        if (selected) {
          selected.querySelector("a").click();
        }
      }
    });

    this.input.addEventListener(
      "input",
      function (e) {
        // console.log('e: ', e);
        if (e.target.value.length === 0) {
          this.emptyDropdown();
          this.hideCloseX();
        }

        if (e.target.value.length >= 3) {
          this.showCloseX();
        }

        if (e.target.value.length < 3 || this.apiLock.locked) {
          return;
        }

        this.apiLock.lock = true;

        setTimeout(() => {
          this.callPredictiveSearchApi();
        }, 500);
      }.bind(this)
    );

    this.emptyDropdown();
    this.hideCloseX();
  }

  callPredictiveSearchApi() {
    if (this.input.value.length === 0) {
      this.apiLock.lock = false;
      return;
    }

    let query = encodeURI(this.input.value.replace(/[^A-Za-z0-9+]/gm, " "));
    // console.log('query:', query);

    if (!query || query === "") {
      this.apiLock.lock = false;

      return;
    }

    if (query.match(/(%20){3,}/g)) {
      this.apiLock.lock = false;
      this.showNoResultUI();

      return;
    }

    fetch(
      `/search/suggest.json?q=${query}&resources[type]=product,collection&resources[options][unavailable_products]=last`
    )
      .then((response) => response.json())
      .then((suggestions) => {
        if (suggestions) {
          let results = suggestions.resources.results;
          console.log(results);

          this.buildDropdown(results);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    this.apiLock.lock = false;
  }

  buildDropdown(results) {
    this.emptyDropdown();

    let totalResultsToShow = 0;
    // a11y: sequential option ids for aria-activedescendant
    let optionIndex = 0;

    if (
      results.collections.length === 0 &&
      results.products.length === 0 &&
      results.pages.length === 0
    ) {
      this.showNoResultUI();
      return;
    }

    // adding collections to dropdown
    if (this.includeCollections) {
      for (let i = 0; i < results.collections.length; i++) {
        const result = results.collections[i];
        let titleLowerCase = result.title.toLowerCase();
        const handle = result.handle;

        if (
          titleLowerCase.includes("test") ||
          titleLowerCase.includes("home page") ||
          this.excludedCollections.includes(handle)
        ) {
          continue;
        }

        // a11y: provide informative alt text for collection image, and role/ids for options
        let listItem = `<li role="option" id="ps-option-${optionIndex++}" class="collection-item" tabindex="-1"><a href="${result.url}"><div class="product-img"><img src="${result.featured_image.url}&width=100" alt="${this.translationCollection}: ${result.title}"></div><div class="product-info"><p class="caption-with-letter-spacing">${this.translationCollection}</p><p class="product-title">${result.title}</p></div></a></li>`;
        this.resultList.innerHTML += listItem;

        totalResultsToShow++;
      }
    }

    // adding products to dropdown
    for (let i = 0; i < results.products.length; i++) {
      const result = results.products[i];
      const tags = result.tags;
      let isTestProduct = false;
      let listItem;
      let titleLowerCase = result.title.toLowerCase();

      // ignore per tag
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i].toLowerCase();
        if (tag.includes("test")) {
          isTestProduct = true;
        }
      }

      if (isTestProduct || tags.includes("#nosearch")) {
        continue;
      }

      if (result.available) {
        // a11y: provide informative alt text for product image, and role/ids for options
        listItem = `<li role="option" id="ps-option-${optionIndex++}" tabindex="-1"><a href="${result.url}"><div class="product-img"><img src="${result.image}&width=100" alt="${result.title}"></div><div class="product-info"><p class="caption-with-letter-spacing">${result.vendor}</p><p class="product-title">${result.title}</p></div></a></li>`;
      } else {
        // a11y: provide informative alt text for product image (sold out), and role/ids for options
        listItem = `<li role="option" id="ps-option-${optionIndex++}" tabindex="-1"><a href="${result.url}"><div class="product-img"><img src="${result.image}&width=100" alt="${result.title}"></div><div class="product-info"><p class="caption-with-letter-spacing">${result.vendor}</p><p class="product-title">${result.title}</p></div></a></li>`; // This is the HTML for soldout products
      }

      this.resultList.innerHTML += listItem;

      totalResultsToShow++;
    }

    // adding pages to dropdown
    for (let i = 0; i < results.pages.length; i++) {
      const result = results.pages[i];
      let titleLowerCase = result.title.toLowerCase();

      if (titleLowerCase.includes("test")) {
        continue;
      }

      let listItem = `<li><a href="${result.url}"><div class="product-info"><p class="caption-with-letter-spacing">Page</p><p class="product-title">${result.title}</p></div></a></li>`;
      this.resultList.innerHTML += listItem;

      totalResultsToShow++;
    }

    this.inputBottomBorder.square();

    if (totalResultsToShow === 0) {
      this.showNoResultUI();
    }

    if (totalResultsToShow > 5) {
      this.resultList.classList.add("show-search-scrollbar");
    }
  }

  emptyDropdown() {
    if (!this.resultList) {
      return;
    }
    while (this.resultList.hasChildNodes()) {
      this.resultList.removeChild(this.resultList.firstChild);
    }

    this.inputBottomBorder.round();
    this.resultList.classList.remove("show-search-scrollbar");
  }

  showCloseX() {
    this.closeX.style.display = "block";
  }

  hideCloseX() {
    this.closeX.style.display = "none";
  }

  showNoResultUI() {
    this.emptyDropdown();
    let listItem = `<li class="no-results" role="option" id="ps-option-${Date.now()}" tabindex="-1"><p>${this.translationNoResults}</p></li>`;
    this.resultList.classList.remove("show-search-scrollbar");
    this.inputBottomBorder.square();
    this.resultList.innerHTML += listItem;
  }
}

customElements.define("predictive-search", predictiveSearch);
